import { flow, types, getEnv, getRoot } from 'mobx-state-tree'

import { InWin } from '.'

const InWins = types
  .model('InWinsModel', {
    items: types.optional(types.map(InWin), {}),
  })
  .actions((self) => {
    const {
      services: { memberService, adminTournamentService },
    } = getEnv(self)

    return {
      add(inwin) {
        if (!inwin) {
          return null
        }

        const trigger = inwin.triggerDTO
        const beneficiary = inwin.beneficiaryDTO
        const root = getRoot(self)

        self.items.set(inwin.id, {
          ...inwin,
          trigger: trigger.id,
          beneficiary: beneficiary.id,
        })

        root.beneficiaries.add(beneficiary)
        root.triggers.add(trigger)

        return self.items.get(inwin?.id)
      },

      create: flow(function* (triggerId, beneficiaryId, amount) {
        const inwinDetail = yield memberService.binaryInWin(
          triggerId,
          beneficiaryId,
          amount
        )
        return self.add(inwinDetail)
      }),

      resolveBinary: flow(function* (eventId, binaryWinner) {
        yield adminTournamentService.resolveBinaryBet(eventId, binaryWinner)
      }),

      load: flow(function* (params) {
        const response = yield memberService.queryInWins(params)
        const inwins = response.content.map((inwin) => self.add(inwin))

        return {
          response,
          inwins,
        }
      }),
    }
  })

export const InWinsRoot = types.model('InWinsRoot', {
  inwins: types.optional(InWins, {}),
})
